/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';
import PlatformUtils from '@appblocks/platforms/PlatformUtils';


export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: Array<CodeBlock> = [];
    if (feature.getSettingValue('ENABLED').toString() === '0') {
        return blocks;
    }
    const capabilities = PlatformUtils.getCapabilities(feature.project);
    const FILES = feature.getSettingValue('FILES');
    const SECTORS = feature.getSettingValue('SECTORS');

    if (feature.project.device.id === 'EM510W' || capabilities.includes('tios_g1')) {
        blocks.push({
            location: 'PROJECT_DEFINES',
            blockType: BlockType.CODE,
            id: '/dOBJECT_FD=FD_ENABLED ',
            template: '/dOBJECT_FD=FD_ENABLED ',
        });
    }

    blocks.push({
        location: 'boot',
        blockType: BlockType.CODE,
        template: `
    'Fd(flash disk) setup
    '================================================================
    if fd.mount<>PL_FD_STATUS_OK then
        if fd.formatj(fd.availableflashspace/4*3,${FILES},${SECTORS})<>PL_FD_STATUS_OK OR fd.totalsize < (fd.availableflashspace/4*3) then
            sys.debugprint("fd.formatj failed")
            sys.halt
        end if
    
        if fd.mount<>PL_FD_STATUS_OK then
            sys.debugprint("fd.mount failed")
            sys.halt
        end if
    end if
    '-----------------------------------------------------------------`,
    });


    return blocks;
};
